import { SurchargeType } from "./enums";

export class Constants {
  public static SORT_RANKS = ["", null, undefined];
  public static EmptyValue = "-";
  public static Comma = ",";
  public static CurrencyDollar = "$";

  public static ExchangeRateUSCN = "ExchangeRateUSCN";
  public static GetCurrentRate = "Get current rate";
  public static PowerBillingPeriod = "Power Billing Period";

  public static LATESTACTION = "LATESTACTION";

  public static SurchargeTypes = [SurchargeType.Energy, SurchargeType.Product];
  public static SurchargeDays = [
    { id: "1", name: "1st" },
    { id: "5", name: "5th" },
    { id: "15", name: "15th" },
  ];
}

export class FieldKeyNames {
  public static Determinant = "Determinant";
  public static Source = "Source";
}

export class FieldKeyValues {
  public static QuarterlySurcharge = "Quarterly Surcharge";
}

export class GridColumnNames {
  public static OldSurcharge = "oldSurcharge";
  public static CalculatedSurcharge = "calculatedSurcharge";
  public static ValidFrom = "validFrom";
  public static ValidTo = "validTo";
}

export class Pages {
  public static SurchargeProcessing = "/surcharge-processing";
  public static Reporting = "/reporting";
  public static FormulaSimulator = "/formula-simulator";
  public static ReviewCustomers = "/surcharge-processing/review-customers";
  public static ReviewProductionIndices = "/surcharge-processing/review-production";
  public static RunSurchargeIncrease = "/surcharge-processing/run-increase";
  public static ReviewNewCharges = "/surcharge-processing/review-charges";
  public static ReviewEmails = "/surcharge-processing/review-emails";
}
